module.exports = __webpack_public_path__ + "img/kiribati.d813b860.svg";